/**
 * @fileoverview DELETE handler for the "/engagement/expressive_reports/:report_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteQueryBuilderReportCacheKeys } from "./constants";
import type { DeleteQueryBuilderReportProps, DeleteQueryBuilderReportResult } from "./types";

export const deleteQueryBuilderReport = reactQueryMutationAdapter(
  deleteQueryBuilderReportCacheKeys,
  (props: DeleteQueryBuilderReportProps): Promise<DeleteQueryBuilderReportResult> => {
    return fetch(`/engagement/expressive_reports/${props.reportId}`, "DELETE", props);
  }
);
